import styled from "styled-components";

const QuestionsBody = (props) => {

    const { questions, handleAddAnswer, answers } = props;

    const handleQuestionByType = (question) => {
        switch (question?.type) {
            case "true_false":
                return (
                    <RadioQuestion>
                        {
                            question?.options?.map((option, index) => (
                                <label key={index}>
                                    <input type="radio" name={question?.question} value={option?.option} onChange={() => handleAddAnswer("true_false", question?.id, option?.id)} />
                                    {option.option}
                                </label>
                            ))
                        }
                    </RadioQuestion>
                )
            case "single_choice":
                return (
                    <RadioQuestion>
                        {
                            question?.options?.map((option, index) => (
                                <label key={index}>
                                    <input type="radio" name={question?.question} value={option?.option} onChange={() => handleAddAnswer("single_choice", question?.id, option?.id)} />
                                    <h3>{`${String.fromCharCode(97 + index)})`}</h3>
                                    {option.option}
                                </label>
                            ))
                        }
                    </RadioQuestion>
                )
            /* case "radio_scale":
                return (
                    <RadioScaleQuestion>
                        {
                            question?.options?.map((option, index) => (
                                <label key={index}>
                                    <input type="radio" name={question?.question} value={option?.option} />
                                    <h3>{index + 1}</h3>
                                    {option.option}
                                </label>
                            ))
                        }
                    </RadioScaleQuestion>
                ) */
            case "open_question":
                return (
                    <TextQuestion>
                        <textarea
                            type="text"
                            placeholder="Escribe aquí tu respuesta"
                            onChange={(e) => handleAddAnswer("open_question", question?.id, e.target.value)}
                            style={{ height: "auto", resize: "vertical" }}
                            onInput={(e) => {
                                e.target.style.height = "auto";
                                e.target.style.height = e.target.scrollHeight + "px";
                            }}
                        />
                    </TextQuestion>
                )
            case "multiple_choice":
                return (
                    <MultipleChoiceQuestion>
                        {
                            question?.options?.map((option, index) => {
                                const isSelected = answers.some(answer =>
                                    answer?.question_id === question?.id &&
                                    answer?.selected_option_ids?.includes(option?.id)
                                );

                                return (
                                    <label key={index}>
                                        <input
                                            type="checkbox"
                                            name={question?.question}
                                            value={option?.option}
                                            checked={isSelected}
                                            onChange={() => handleAddAnswer("multiple_choice", question?.id, option?.id)}
                                        />
                                        <h3>{`${String.fromCharCode(97 + index)})`}</h3>
                                        {option?.option}
                                    </label>
                                );
                            })
                        }
                    </MultipleChoiceQuestion>
                )
            /* case "multiple-text":
                return (
                    <>
                        {
                            question?.options?.map((option, index) => (
                                <MultipleTextQuestion key={index}>
                                    <span>
                                        <h3>{`${String.fromCharCode(97 + index)})`}</h3>
                                        <label>{option?.value}</label>
                                    </span>
                                    <input type="text" placeholder="Escribe aquí tu respuesta" />
                                </MultipleTextQuestion>
                            ))
                        }
                    </>
                ) */
            default:
                return null;
        }
    }

    return (
        <Container>
            {
                questions?.map((question, index) => (
                    <Question key={index}>
                        <label>{index + 1}. {question?.question}</label>
                        {handleQuestionByType(question)}
                    </Question>
                ))
            }
        </Container>
    )
}

export default QuestionsBody;

const Container = styled.div`
    width: calc(100% - 4rem);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    color: #222;
`

const Question = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    label {
        font-size: 18px;
        font-weight: 700;
        color: #222;
    }
`

const RadioQuestion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    label {
        display: flex;
        align-items: center;
        gap: 1rem;

        input[type="radio"] {
            appearance: none;
            min-width: 20px;
            width: 20px;
            height: 20px;
            border: 2px solid #49454F; /* Borde oscuro para radio inactivo */
            border-radius: 50%;
            outline: none;
            background-color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }

        /* Efecto cuando está seleccionado */
        input[type="radio"]:checked {
            border-color: #b31d15; /* Borde rojo */
            background-color: #fff; /* Fondo rojo */
        }

        /* Punto interno cuando está seleccionado */
        input[type="radio"]:checked::after {
            content: "";
            width: 10px;
            height: 10px;
            background-color: #b31d15;
            border-radius: 50%;
            position: absolute;
        }
    }
`

const TextQuestion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    textarea {
        width: calc(100% - 1rem);
        height: fit-content;
        padding-top: 1rem;
        padding-left: 1rem;
        border: 0;
    }
`

const MultipleChoiceQuestion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    label {
        display: flex;
        align-items: center;
        gap: 1rem;

        input[type="checkbox"] {
            appearance: none;
            min-width: 20px;
            width: 20px;
            height: 20px;
            border: 2px solid #49454F; /* Borde oscuro para checkbox inactivo */
            outline: none;
            background-color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }

        /* Efecto cuando está seleccionado */
        input[type="checkbox"]:checked {
            border-color: #b31d15; /* Borde rojo */
            background-color: #fff; /* Fondo rojo */
        }

        /* Cuadrado interno cuando está seleccionado */
        input[type="checkbox"]:checked::after {
            content: "";
            width: 10px;
            height: 10px;
            background-color: #b31d15;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
`